export default {
  path: '/dynamicManage',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/devOpsManage/home',
  children: [
    {
      // 首页
      path: 'index',
      name: 'dynamicManage',
      component: () => import('./index')
    },
    {
      path: 'table',
      name: 'dynamicManageTable',
      component: () => import('./dynamicTable')
    },
    {
      path: 'createMessage',
      name: 'dynamicManageCreateMessage',
      component: () => import('./dynamicTable/marketHot/createMessage')
    },
    {
      path: 'detail',
      component: () => import('@/pages/dynamicManage/marketHot/hotItem/detail'),
      children: [
        {
          path: 'exhibition',
          name: 'dynamicManageExhibition',
          component: () => import('./marketHot/hotItem/exhibitionDetail')
        },
        {
          path: 'message',
          name: 'dynamicManageMessage',
          component: () => import('./marketHot/hotItem/messageDetail')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/dynamicManage/router.js